export default {
  inject: ['$validator'],
  props: {
    label: String,
    scope: String,
    options: [Array, Object],
    name: String,
    placeholder: String,
    hasLabel: {
      type: Boolean,
      default: true
    },
    showCounter: {
      default: false,
      type: Boolean
    },
    showError: {
      default: true,
      type: Boolean
    },
    value: [String, Number, File],
    rules: Array
  },
  data: () => ({
    model: null
  }),
  computed: {
    isRequired () {
      if (this.rules) {
        return this.rules.indexOf('required') > -1
      }
    },
    hasError () {
      if (this.hasScope) {
        return this.errors.has(this.scope + '.' + this.name)
      }

      return this.errors.has(this.name)
    },
    getErrorMessage () {
      if (this.hasScope) {
        return this.errors.first(this.scope + '.' + this.name)
      }

      return this.errors.first(this.name)
    },
    hasScope () {
      return this.scope
    },
    getRules () {
      if (this.rules) {
        return this.rules.join('|')
      }
    },
    charCount () {
      return this.model.length
    },
    maxCount () {
      const maxRule = this.rules.filter(rule => rule.startsWith('max'))

      if (maxRule.length) {
        return maxRule[0].split(':')[1]
      }

      return false
    }
  },
  watch: {
    model (value) {
      this.$emit('input', value)
    },
    value (value) {
      this.model = value
    }
  },
  created () {
    this.model = this.value
  },
  mounted () {
    this.$eventHub.$on('validate-fields', () => {
      this.$validator.validateAll()
    })
  }
}
